module.exports = __webpack_public_path__ + "static/man_set_1toddler.5036523b.svg";